module.exports = __webpack_public_path__ + "static/media/lomalla.8788d1e4.jpg";